import { faHeart, faUser } from "@fortawesome/free-regular-svg-icons";
import {
  faCartShopping,
  faUserDoctor,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AllyNorLogo from "assets/images/AllynorLogo.jpg";
import callApi from "../../services/api";
import { useRecoilState } from "recoil";
import { AlertState } from "../GlobalStates/AlertState";

const Header = () => {
  const navigate = useNavigate();
  const [_, setAlertMessage]= useRecoilState(AlertState);

  const [menu, setMenu] = useState([]);

  useEffect(() => {
    if (menu.length === 0) getMenu();
  });

  const getMenu = async () => {
    var response = await callApi(
      "/marketing/marketing-menu",
      "GET",
      null,
      true,
      false,
      setAlertMessage
    );
    if (response.status !== 200) console.log(response.message);
    else {
      setMenu(response?.body);
    }
  };

  const renderSubSubMenu = (subSubMenu) => (
    <ul className="dropdown-menu">
      {subSubMenu.map((subSubItem) => (
        <li key={subSubItem.moduleName} className="nav-item">
          <a
            className="dropdown-item cursor-pointer"
            onClick={() => navigate(subSubItem.url)}
          >
            {subSubItem.moduleName}
          </a>
        </li>
      ))}
    </ul>
  );

  const renderSubMenu = (subMenu) => (
    <ul className="dropdown-menu" data-bs-auto-close="outside">
      {subMenu.map((subItem) => (
        <li
          key={subItem.moduleSectionName}
          className={
            subItem.marketingModuleSubSubSectionVOs.length > 0
              ? "dropend nav-item dropdown"
              : "nav-item"
          }
        >
          {subItem.url ? (
            <a
              className="dropdown-item cursor-pointer"
              onClick={() => navigate(subItem.url)}
            >
              {subItem.moduleSectionName}
            </a>
          ) : (
            <>
              <a
                className="dropdown-item dropdown-toggle cursor-pointer"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                data-bs-auto-close="outside"
              >
                {subItem.moduleSectionName}
              </a>
              {renderSubSubMenu(subItem.marketingModuleSubSubSectionVOs)}
            </>
          )}
        </li>
      ))}
    </ul>
  );

  const renderMenu = (menuItems) => (
    <ul className="navbar-nav ms-lg-4 mb-3">
      {menuItems.map((item) => (
        <li
          key={item.moduleName}
          className={
            item.marketingModuleSubSectionVOs.length > 0
              ? "nav-item dropdown"
              : "nav-item"
          }
        >
          {item.url ? (
            <a
              className="nav-link cursor-pointer"
              onClick={() => navigate(item.url)}
            >
              {item.moduleName}
            </a>
          ) : (
            <>
              <a
                className="nav-link dropdown-toggle cursor-pointer"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                data-bs-auto-close="outside"
              >
                {item.moduleName}
              </a>
              {renderSubMenu(item.marketingModuleSubSectionVOs)}
            </>
          )}
        </li>
      ))}
    </ul>
  );

  return (
    <>
      <header className="navbar navbar-expand-lg bg-body sticky-top p-0 ">
        <div className="container py-3 d-flex justify-content-between align-items-center">
          <a className="navbar-brand" href="#">
            <img
              src={AllyNorLogo}
              alt="Allynor_Logo"
              style={{ height: "60px", width: "200px" }}
            />
          </a>

          <button
            type="button"
            className="navbar-toggler"
            data-bs-toggle="offcanvas"
            data-bs-target="#navbarOffcanvas"
            aria-controls="navbarOffcanvas"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="offcanvas offcanvas-end"
            id="navbarOffcanvas"
            tabIndex="-1"
            aria-labelledby="navbarOffcanvasLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="navbarOffcanvasLabel">
                Menu
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body d-flex justify-content-between">
              {renderMenu(menu)}

              <ul className="navbar-nav ms-auto">
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle cursor-pointer"
                    role="button"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                    aria-expanded="false"
                    style={{ fontSize: "20px" }}
                  >
                    <FontAwesomeIcon icon={faUser} />
                  </a>
                  <ul className="dropdown-menu">
                    {!localStorage.getItem("token") ? (
                      <>
                        <li>
                          <a
                            className="dropdown-item cursor-pointer"
                            onClick={() => {
                              navigate("/login", { state: { role: "DOCTOR" } });
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faUserDoctor}
                              className="me-2"
                            />
                            Login as Doctor
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item cursor-pointer"
                            onClick={() => {
                              navigate("/login", {
                                state: { role: "CUSTOMER" },
                              });
                            }}
                          >
                            <FontAwesomeIcon icon={faUser} className="me-2" />
                            Login as Customer
                          </a>
                        </li>
                      </>
                    ) : (
                      <li>
                        <a
                          className="dropdown-item cursor-pointer"
                          onClick={() => {
                            localStorage.clear();
                            navigate("/");
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faSignOutAlt}
                            className="me-2"
                          />{" "}
                          {/* Logout icon */}
                          Logout
                        </a>
                      </li>
                    )}
                  </ul>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link active cursor-pointer"
                    aria-current="page"
                    onClick={() => {
                      navigate("/wishlist");
                    }}
                    style={{ fontSize: "20px", paddingTop: "11px" }}
                  >
                    <FontAwesomeIcon icon={faHeart} />
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link active cursor-pointer"
                    aria-current="page"
                    onClick={() => {
                      navigate("/cart");
                    }}
                    style={{ fontSize: "20px", paddingTop: "11px" }}
                  >
                    <FontAwesomeIcon icon={faCartShopping} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
